import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { Page, TLCode } from '../../common/enums';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { observer } from 'mobx-react';
import BaseGridXL from '../common/grid/BaseGridXL';
import styled from '@emotion/styled';
import { SystemStatus } from '../../store/models/SystemStatus';
import SystemStatusForm from './SystemStatusForm';
import EditCell from '../common/grid/EditCell';
import { Button, Intent } from '@blueprintjs/core';
import moment from 'moment';


const ButtonsContainer = styled.div({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'flex-end',
  marginBottom: 5,
});

interface BlackPointManagerProps extends WithTranslateProps {
  blackPointSystemStatus: Array<Instance<typeof SystemStatus>>;
  onStatusSave: (data: Instance<typeof SystemStatus>) => void;
  secretariatId: number;
  navigate: (url: string) => void;
}

interface BlackPointManagerState {
  systemStatusEdition?: Instance<typeof SystemStatus>;
}

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

@observer
class BlackPointManager extends React.Component<BlackPointManagerProps, BlackPointManagerState> {
  state = {
    systemStatusEdition: undefined,
  } as BlackPointManagerState;

  columns = [
    { headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_Year), field: 'year', sort: 'desc' },
    { headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_Status), field: 'status' },
    {
      width: 100,
      headerName: '',
      sortable: false,
      filter: false,
      cellRendererFramework: EditCell,
      cellRendererParams: (params: ICellRendererParams) => {
        return {
          onEditButtonClick: () => {
            this.startEdition(params.data.id);
          },
        };
      },
    },
  ] as ColDef[];

  buildGridData = () => {
    return this.props.blackPointSystemStatus.map((ss) => ({
      id: ss.systemStatusId,
      year: ss.year,
      status: ss.status,
    }));
  };

  onRowDoubleClicked = (ev) => {
    this.props.navigate(`${Page.PharmacyPage}/${ev.data.pharmacyId}`);
  };

  startEdition = (id: number) => {
    const status = this.props.blackPointSystemStatus.find((elem) => elem.systemStatusId === id);
    this.setState({ systemStatusEdition: status });
  };

  stopEdition = () => {
    this.setState({ systemStatusEdition: undefined });
  };

  save = (data: Instance<typeof SystemStatus>) => {
    this.props.onStatusSave(data);
    this.stopEdition();
  };

  render() {
    const { systemStatusEdition } = this.state;
    const { translate, secretariatId } = this.props;

    return (
      <Container>
        <ButtonsContainer>
          <Button
            text={translate(TLCode.Add)}
            intent={Intent.PRIMARY}
            onClick={() => {
              this.setState({
                systemStatusEdition: SystemStatus.create({
                  systemStatusId: 0,
                  secretariatId,
                  status: 'EncodingOpen',
                  year: moment().year(),
                  subSystem: 'Blackpoint',
                }),
              });
            }}
          />
        </ButtonsContainer>
        <BaseGridXL
          columnDefs={this.columns}
          rowData={this.buildGridData()}
          keyName="pharmacyId"
          onRowDoubleClicked={this.onRowDoubleClicked}
          suppressClickEdit={true}
        />
        <SystemStatusForm
          systemStatus={systemStatusEdition}
          onSave={this.save}
          onStop={this.stopEdition}
          status={['EncodingClosed', 'EncodingOpen']}
        />
      </Container>
    );
  }
}

export default withTranslate(BlackPointManager);
